// @flow
import { configString } from 'utils/config';

const getGradSchoolsSearchIndex = (sort: ?string) => {
  if (sort === undefined || sort === null || sort === '') {
    sort = 'program-name-asc';
  }
  const gradIndexName = configString('algolia', 'gradschoolsIndexName');
  return `${gradIndexName}-${sort}`;
};

export default getGradSchoolsSearchIndex;
